var _path, _path2, _polygon, _polygon2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M37,33h-3v-4h3c3.309,0,6-2.691,6-6v-5h-9v-4h13v9C47,28.514,42.514,33,37,33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M34,43H14L9,6H39L34,43z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "32,29 32,33 35.351,33 35.892,29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "34,18 37.379,18 37.919,14 34,14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5bc00",
    points: "21,17 21,6 17,6 17,17 15,17 15,25 23,25 23,17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.f0128b1c081f616a8cd5c5ba50204f9b.svg";
export { ForwardRef as ReactComponent };